import { cn } from "../lib/cn"

export type CorDaParte = "sucesso" | "atencao" | "erro" | "neutro"

export type Parte = {
  chave: string
  rotulo: string
  valor: number
  cor: CorDaParte
}

const COR: Record<CorDaParte, string> = {
  sucesso: "bg-status-sucesso",
  atencao: "bg-status-atencao",
  erro: "bg-status-erro",
  neutro: "bg-muted-foreground",
}

export function BarraEmPartes({ partes, rotulo }: { partes: Parte[]; rotulo: string }) {
  const total = partes.reduce((soma, parte) => soma + parte.valor, 0)
  const percentual = (valor: number) => (total === 0 ? 0 : Math.round((valor / total) * 100))
  const descricao = partes.map((p) => `${p.rotulo} ${p.valor} (${percentual(p.valor)}%)`).join(", ")
  return (
    <div className="flex flex-col gap-3">
      <div role="img" aria-label={`${rotulo}: ${descricao}`} className="flex h-3 gap-0.5 overflow-hidden rounded-full bg-muted">
        {partes
          .filter((parte) => parte.valor > 0)
          .map((parte) => (
            <span
              key={parte.chave}
              data-slot="parte"
              data-chave={parte.chave}
              className={cn("block h-full min-w-1", COR[parte.cor])}
              style={{ flexGrow: parte.valor, flexBasis: 0 }}
            />
          ))}
      </div>
      <ul className="m-0 flex list-none flex-col gap-1.5 p-0 text-sm">
        {partes.map((parte) => (
          <li key={parte.chave} className="flex items-center gap-2">
            <span aria-hidden="true" className={cn("size-2.5 shrink-0 rounded-sm", COR[parte.cor])} />
            <span className="min-w-0 flex-1 first-letter:uppercase">{parte.rotulo}</span>
            <span className="font-semibold whitespace-nowrap tabular-nums">
              {parte.valor.toLocaleString("pt-BR")} ({percentual(parte.valor)}%)
            </span>
          </li>
        ))}
      </ul>
    </div>
  )
}
